/**
 * Helper method to watch changes inside a target element.
 * @param {HTMLElement} targetElement - The element to observe.
 * @param {Function} callback - Function to execute when changes occur.
 * @returns {MutationObserver} The created observer instance.
 */
function watchElementChanges(targetElement, callback) {
    if (!targetElement) {
        throw new Error("Target element is required.");
    }
    if (typeof callback !== "function") {
        throw new Error("Callback must be a function.");
    }

    // Create a MutationObserver instance
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                callback(mutation);
            }
        }
    });

    // Configure the observer to watch for changes in child elements
    const config = { childList: true, subtree: true };

    // Start observing the target element
    observer.observe(targetElement, config);

    // Return the observer instance to allow for manual disconnect if needed
    return observer;
}

export default watchElementChanges;
